var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk } from '@reduxjs/toolkit';
import { API_BASE_URL, getHeadersForFrontendCall } from '../../api/helpers';
import { isStoryteller } from '../../types';
export var AppConfigurationActionType;
(function (AppConfigurationActionType) {
    AppConfigurationActionType["FETCH_CONFIGURATION"] = "FETCH_CONFIGURATION";
})(AppConfigurationActionType || (AppConfigurationActionType = {}));
export const fetchConfiguration = createAsyncThunk(AppConfigurationActionType.FETCH_CONFIGURATION, (_a) => __awaiter(void 0, [_a], void 0, function* ({ proxyApp }) {
    let appConfigResponse;
    try {
        if (API_BASE_URL === 'http://localhost:3456') {
            appConfigResponse = yield fetch(`${API_BASE_URL}/config/client`);
        }
        else {
            const headers = getHeadersForFrontendCall();
            const url = isStoryteller(proxyApp) ? '/stories/api/v1/chatbot/config' : '/data_assistant/config';
            appConfigResponse = yield fetch(url, {
                credentials: 'include',
                headers,
            });
        }
        if (!appConfigResponse.ok) {
            throw new Error(yield appConfigResponse.text());
        }
        return appConfigResponse.json();
    }
    catch (error) {
        console.error(`Error getting app config: ${error}`);
    }
}));
//# sourceMappingURL=appConfiguration.js.map